import { render, staticRenderFns } from "./success_h5.vue?vue&type=template&id=37ae3fe9"
import script from "./success_h5.vue?vue&type=script&lang=js"
export * from "./success_h5.vue?vue&type=script&lang=js"
import style0 from "./success_h5.vue?vue&type=style&index=0&id=37ae3fe9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports